// Where a visitor first landed and where they came from, kept in the browser until they
// have an account. Ad blockers drop the analytics hit on the landing page but not
// localStorage, so this survives when Amplitude's attribution does not.
const KEY = 'midimate_first_touch';

export function rememberFirstTouch() {
  try {
    if (localStorage.getItem(KEY)) return;
    localStorage.setItem(KEY, JSON.stringify({
      url: window.location.href.slice(0, 2000),
      referrer: (document.referrer || '').slice(0, 2000),
      at: new Date().toISOString(),
    }));
  } catch (e) {
    // storage off: attribution falls back to whatever analytics saw
  }
}

export function readFirstTouch() {
  try {
    return JSON.parse(localStorage.getItem(KEY) || 'null');
  } catch (e) {
    return null;
  }
}
